export const sortByFields = (items, sortFields, sortValue) => {
  const activeFields = (sortFields ?? [])
    .filter(field => field.sort !== null)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  return [...items].sort((a, b) => {
    for (const field of activeFields) {
      const valueA = sortValue(a, field.field)
      const valueB = sortValue(b, field.field)
      if (valueA === valueB) continue
      if (valueA === null) return 1
      if (valueB === null) return -1
      return (valueA < valueB ? -1 : 1) * (field.sort === 'asc' ? 1 : -1)
    }
    return 0
  })
}
